import React, { useMemo, useState } from "react";
import {
  ArtDescriptionContainer,
  ArtImage,
  ContentContainer,
  CreatePasswordContainer,
  ImageContainer,
  MainContainer,
  SubtitleContainer,
} from "./styles";
import Art1 from "../../assets/png/artBackground/art1.png";
import Art2 from "../../assets/png/artBackground/art2.png";
import Art3 from "../../assets/png/artBackground/art3.png";
import Art4 from "../../assets/png/artBackground/art4.png";
import Art5 from "../../assets/png/artBackground/art5.png";
import Typography from "../../components/Typography";
import TextInput from "../../components/TextInput";
import Button from "../../components/Button";
import { authService } from "../../services/modules/auth";
import { Form } from "./types";
import useAuth from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import PasswordInput from "../../components/PasswordInput";

const initialValues: Form = {
  email: "",
  password: "",
};

const Login: React.FC = (): JSX.Element => {
  const navigate = useNavigate();
  const { persistToken } = useAuth();

  const [form, setForm] = useState<Form>(initialValues);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getRandomImage = () => {
    const images = [
      {
        image: Art1,
        author: "Vincent van Gogh (1890)",
        title: "Green Wheat Fields, Auvers",
      },
      {
        image: Art2,
        author: "Henri-Edmond Cross (1898)",
        title: "Les Champs-Elysées",
      },
      {
        image: Art3,
        author: "Vincent van Gogh (1889 - 1889)",
        title: "Sunflowers",
      },
      { image: Art4, author: "Lee Seahyun (2008)", title: "Between Red_044" },
      {
        image: Art5,
        author: "James Turrell",
        title: "The Light Inside (Supplemental)",
      },
    ];

    const randomIndex = Math.floor(Math.random() * images.length);
    return images[randomIndex];
  };

  const imageInfo = useMemo(() => getRandomImage(), []);

  const handleLogin = () => {
    setIsLoading(true);

    authService
      .signIn(form)
      .then((response) => persistToken(response.access_token))
      .finally(() => setIsLoading(false));
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <MainContainer>
      <ContentContainer onKeyDown={handleKeyDown} tabIndex={0}>
        <div style={{ whiteSpace: "nowrap" }}>
          <Typography text="Olá novamente! 👋" size="extraHuge" />
        </div>
        <SubtitleContainer>
          <Typography
            text="Deixe sua criatividade fluir."
            size="large"
            color="Black400"
            weight={400}
          />
          <Typography
            text="Nós cuidamos do resto pra você."
            size="large"
            color="Black400"
            weight={400}
          />
          <Typography
            text="Faça login e comece já."
            size="large"
            color="Black400"
            weight={400}
          />
        </SubtitleContainer>
        <TextInput
          placeholder="E-mail"
          onChange={(e) =>
            setForm((prev) => ({ ...prev, email: e.target.value }))
          }
        />
        <PasswordInput
          placeholder="Senha"
          iconRender={(visible: boolean) =>
            visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
          }
          visibilityToggle={true}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setForm((prev) => ({ ...prev, password: e.target.value }))
          }
        />
        <Button onClick={handleLogin} loading={isLoading}>
          Entrar
        </Button>
        <CreatePasswordContainer onClick={() => navigate("/cadastro")}>
          <Typography
            text="Criar nova conta"
            size="medium"
            color="Blue300"
            weight={400}
          />
        </CreatePasswordContainer>
      </ContentContainer>
      <ImageContainer>
        <ArtImage src={imageInfo.image} />
        <ArtDescriptionContainer>
          <Typography
            text="Inspire-se com"
            size="medium"
            color="Black100"
            weight={400}
          />
          <Typography
            text={imageInfo.title}
            size="medium"
            color="Black100"
            weight={600}
          />
          <Typography
            text={`- ${imageInfo.author}`}
            size="medium"
            color="Black100"
            weight={400}
          />
        </ArtDescriptionContainer>
      </ImageContainer>
    </MainContainer>
  );
};

export default Login;
